<div class="accordion m-2" id="accordionTarget">
	<div class="accordion-item p-0 mt-2" style="border-left:10px solid #B65250; border-radius: 10px">
	<h3>
			<div class="card-header  p-0" style="border: 0px; border-radius: 0px 10px 10px 0px">
					<button class="accordion-button" #accordionButton type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" data-book-id="1011" aria-expanded="true" aria-controls="panelsStayOpen-collapseOne">
					<i class="fa fa-chevron-down accordion-icon tw-me-2"></i>
					<i class="fa fa-chevron-up accordion-icon tw-me-2"></i>
					{{phases?.[0].title ||  "Phase 1"}}
					</button>
			</div>
	</h3>
			<div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse show" data-bs-parent="accordionTarget">
					<div class="accordion-body p-0">
							<app-progress-table phase="1" [sorting]="this.currentSavedColumns" [defaultSorting]="this.defaultColumns" [filterText]="filterText" (outgoingSorting)="recieveSortingBroadcast($event)" (filterTextChange)="filterText = $event"></app-progress-table>
					</div>
			</div>
	</div>

	<div class="accordion-item  p-0 mt-2" style="border-left:10px solid #7D5FAA; border-radius: 10px">
			<h3>
					<div class="card-header  p-0" style="border: 0px; border-radius: 0px 10px 10px 0px">
							<button class="accordion-button collapsed" #accordionButton type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTwo" data-book-id="1012" aria-expanded="false" aria-controls="panelsStayOpen-collapseTwo">
									<i class="fa fa-chevron-down accordion-icon tw-me-2"></i>
									<i class="fa fa-chevron-up accordion-icon tw-me-2"></i>
									{{phases?.[1].title ||  "Phase 2"}}
							</button>
					</div>
			</h3>
			<div id="panelsStayOpen-collapseTwo" class="accordion-collapse collapse" data-bs-parent="accordionTarget">
					<div class="accordion-body p-0">
							<app-progress-table phase="2" [sorting]="this.currentSavedColumns" [defaultSorting]="this.defaultColumns" [filterText]="filterText" (outgoingSorting)="recieveSortingBroadcast($event)" (filterTextChange)="filterText = $event"></app-progress-table>
					</div>
			</div>
	</div>

	<div class="accordion-item p-0 mt-2" style="border-left:10px solid #435F90; border-radius: 10px">
			<h3>
					<div class="card-header p-0" style="border: 0px; border-radius: 0px 10px 10px 0px">
							<button class="accordion-button collapsed" #accordionButton type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseThree" data-book-id="1013" aria-expanded="false" aria-controls="panelsStayOpen-collapseThree">
									<i class="fa fa-chevron-down accordion-icon tw-me-2"></i>
									<i class="fa fa-chevron-up accordion-icon tw-me-2"></i>
									{{phases?.[2].title ||  "Phase 3"}}
							</button>
					</div>
			</h3>
			<div id="panelsStayOpen-collapseThree" class="accordion-collapse collapse" data-bs-parent="accordionTarget">
					<div class="accordion-body p-0">
							<app-progress-table phase="3" [sorting]="this.currentSavedColumns" [defaultSorting]="this.defaultColumns" [filterText]="filterText" (outgoingSorting)="recieveSortingBroadcast($event)" (filterTextChange)="filterText = $event"></app-progress-table>
					</div>
			</div>
	</div>
</div>
